if (window.matchMedia('(max-width:768px)').matches) {
  if (document.getElementById('product-box-reivew-carousel')) {
    let fragment = document.createDocumentFragment();
    fragment.appendChild(document.querySelector('.instagram-feed-zoom'));
    let boxReviews = document.getElementById('product-box-reivew-carousel');

    boxReviews.after(fragment);
  }

  if (document.getElementById('product-temperature-bar')) {
    let fragment2 = document.createDocumentFragment();
    fragment2.appendChild(document.querySelector('.Product__Press'));
    let comparison = document.getElementById('product-temperature-bar');

    comparison.after(fragment2);
  }
}

function loadJQueryForInsta() {
  var waitForLoad = function () {
    if (typeof jQuery != "undefined") {
      $('.instagram-feed-zoom .ZoomList').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: $('.ZoomImageWrapper').length > 5 ? true : false,
        autoplay:false,
        variableWidth: false,
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              dots: $('.ZoomImageWrapper').length > 4 ? true : false,
            }
          },
          {
            breakpoint: 885,
            settings: {
              slidesToShow: 3,
              dots: $('.ZoomImageWrapper').length > 3 ? true : false,
            }
          },
          {
            breakpoint: 560,
            settings: {
              slidesToShow: 1,
              dots: true
            }
          }
        ]
      });

      const photoswipe = () => {
        let container = [];
        const gallery = document.querySelector(".ZoomList");
        const galleryImageWrappers = gallery.querySelectorAll(".ZoomList .ZoomImageWrapper");
        
        galleryImageWrappers.forEach(wrapper => {
          const link = wrapper.querySelector('a')
          const item = {
            src: link.getAttribute("href"),
            w: link.dataset.width,
            h: link.dataset.height,
            title: link.dataset.caption,
          }
          container.push(item)
        })
        
        const galleryLinks = document.querySelectorAll(".ZoomImageWrapper .ZoomImageLink")
        galleryLinks.forEach(link => {
          link.addEventListener("click", e => {
            e.preventDefault();
            
            const wrapper = link.parentElement;
            const wrapperIndex = wrapper.dataset.index;
            
            // Define object and gallery options
            const pswp = document.querySelector('.pswp')
            const options = {
              index: wrapperIndex,
              showHideOpacity: true,
              showAnimationDuration: 500,
              loop: false,
              history: false,
              closeOnVerticalDrag: false,
              allowPanToNext: false,
              pinchToClose: false,
              errorMsg: '<p class="pswp__error-msg">' + window.languages.productImageLoadingError + '</p>',
              scaleMode: 'zoom',
              getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
                if (isMouseClick) {
                  return 1.6;
                } else {
                  return item.initialZoomLevel < 0.7 ? 1 : 1.33;
                }
              }
            };
            
            // Initialize PhotoSwipe
            const gallery = new PhotoSwipe(pswp, false, container, options);

            const delegateRoot = new domDelegate.Delegate(document.body);

            const _onSingleTap = (event) => {
              if (event.detail.target.classList.contains('pswp__button--close')) {
                setTimeout(function () {
                  event.target.closest('.pswp').classList = 'pswp';
                }, 500);
                gallery.close();

              } else if (!event.detail || event.detail.pointerType === 'mouse') {
                if (event.target.classList.contains('pswp__img')) {
                  gallery.toggleDesktopZoom(event.detail.releasePoint);
                }
              } else {
                if (event.target.classList.contains('pswp__button')) {
                  return;
                }
                event.target.closest('.pswp').querySelector('.pswp__ui').classList.toggle('pswp__ui--hidden');
              }
            }

            const _onDoubleTap = (point) => {
              var initialZoomLevel = gallery.currItem.initialZoomLevel;

              if (gallery.getZoomLevel() !== initialZoomLevel) {
                gallery.zoomTo(initialZoomLevel, point, 333);
              } else {
                gallery.zoomTo(initialZoomLevel < 0.7 ? 1 : 1.33, point, 333);
              }
            }
            const _onInitialZoomIn = () => {
              document.querySelector('.pswp__ui').classList.remove('pswp__ui--hidden');
            }
            const _onInitialZoomOut = () => {
              document.querySelector('.pswp__ui').classList.add('pswp__ui--hidden');
            }

            gallery.listen('onDoubleTap', _onDoubleTap.bind(this));
            gallery.listen('initialZoomIn', _onInitialZoomIn.bind(this));
            gallery.listen('initialZoomOut', _onInitialZoomOut.bind(this));
            
            delegateRoot.on('pswpTap', '.pswp__scroll-wrap', _onSingleTap.bind(this));
            delegateRoot.on('pswpTap', '.pswp__button--close', _onSingleTap.bind(this));
            delegateRoot.on('pswpTap', '.pswp__button--prev', gallery.prev);
            delegateRoot.on('pswpTap', '.pswp__button--next', gallery.next);

            gallery.init();
            
          })
        })
      }

      photoswipe();
    } else {
      console.log("jquery not loaded..");
      window.setTimeout(waitForLoad, 500);
    }
  };
  window.setTimeout(waitForLoad, 500);
}

loadJQueryForInsta();